import { createTheme, alpha } from '@mui/material/styles';

const baseTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#db4481', // Using the pink from the header gradient
    },
    secondary: {
      main: '#ffffff',
    },
    info: {
      main: '#90caf9',
    },
    background: {
      default: '#121212',
      paper: '#1e1e1e',
    },
    text: {
      primary: '#ffffff',
      secondary: 'rgba(255, 255, 255, 0.7)',
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: 'var(--header-gradient)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: 'rgba(219, 68, 129, 0.08)',
            '&:hover': {
              backgroundColor: 'rgba(219, 68, 129, 0.12)',
            },
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
  },
});

const autofillBg = alpha(baseTheme.palette.info.main, 0.28);

const webkitAutofill = {
  WebkitBoxShadow: `0 0 0 100px ${autofillBg} inset`,
  WebkitTextFillColor: `${baseTheme.palette.text.primary} !important`,
  caretColor: baseTheme.palette.text.primary,
  transition: 'background-color 5000s ease-in-out 0s',
};

const theme = createTheme(baseTheme, {
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          '&:-webkit-autofill': webkitAutofill,
          '&:-webkit-autofill:hover': webkitAutofill,
          '&:-webkit-autofill:focus': webkitAutofill,
          '&:-webkit-autofill:active': webkitAutofill,
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        input: {
          '&:-webkit-autofill': webkitAutofill,
          '&:-webkit-autofill:hover': webkitAutofill,
          '&:-webkit-autofill:focus': webkitAutofill,
          '&:-webkit-autofill:active': webkitAutofill,
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        input: {
          '&:-webkit-autofill': webkitAutofill,
          '&:-webkit-autofill:hover': webkitAutofill,
          '&:-webkit-autofill:focus': webkitAutofill,
          '&:-webkit-autofill:active': webkitAutofill,
        },
      },
    },
  },
});

export default theme;
